import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderEligibilitiesMockEligibleToRefundWithUnOneWay,
  orderWithScheduleChange,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const scheduleChangeOneWayMock: MockMap = {
  retrieveOrder: [createMockData(orderWithScheduleChange, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundWithUnOneWay, [], [orderNotEligibleForRefundWarning])]
};
